import { ca } from '@cian/analytics';

export function trackAddCommentClick() {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'moreMenu_add_comment',
  });
}
